import { Type } from '@angular/core';

/**
 * In addition to containing the component to be built, contains other class fields
 * e.g. class, size and supplementary data, needed to style and fill a dynamic component
 */
export class FormItem {
    constructor(public component: Type<any>, public classes?: string[], public fieldSize?: string, public data?: any) {}
}
